import { Text, XStack, YStack } from "tamagui";
import KioskIcon from "../KioskIcon";
import { kiosk } from "../kioskTheme";

/** 首頁送達地址卡（點「變更」開地址選單）。 */
const HomeAddressCard = ({ address, onChange }: { address: string; onChange: () => void }) => (
  <XStack
    backgroundColor={kiosk.card}
    borderWidth={1}
    borderColor={kiosk.line}
    borderRadius={15}
    p={13}
    ai="center"
    gap={11}
    mb={16}
    cursor="pointer"
    onPress={onChange}
    pressStyle={{ scale: 0.99 }}
    >
    <KioskIcon name="pin" size={24} color={kiosk.blue} />
    <YStack flex={1} minWidth={0}>
      <Text fontSize={13} color={kiosk.grey}>
        送達地址
      </Text>
      <Text fontSize={16} fontWeight="700" mt={2} lineHeight={22} color={kiosk.ink} style={{ wordBreak: "break-all" } as any}>
        {address}
      </Text>
    </YStack>
    <Text color={kiosk.blue} fontSize={14} fontWeight="700" flexShrink={0} style={{ whiteSpace: "nowrap" } as any}>
      變更
    </Text>
  </XStack>
);

export default HomeAddressCard;
